import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

/**
 * The drawings sub-pages' detail header (Figma 33128:76594, "Geo title"): a ‹ back chevron inline before a 28/700 title,
 * the page's ••• beside the title, a 14/400 subtitle and a row of status badges below it. Set review, the sheet viewer,
 * compare and the carry-forward review use it in place of the old "← Drawings" link row.
 *
 * Slots: `[headerMenu]` (the •••, beside the title), `[headerSub]` (extra lines under the subtitle), `[headerChips]`
 * (status badges) and `[headerActions]` (a primary action at the far right, which the Figma pattern has no slot for).
 */
@Component({
  selector: 'app-drawings-page-header',
  templateUrl: './drawings-page-header.component.html',
  styleUrls: ['./drawings-page-header.component.scss'],
  imports: [MatIconModule],
})
export class DrawingsPageHeaderComponent {
  @Input() title = '';
  @Input() subtitle = '';
  /** The back chevron's accessible name, e.g. "Back to Drawings" */
  @Input() backLabel = 'Back to Drawings';
  /** data-testid on the back button (the pages' existing ids) and on the title */
  @Input() backTestId = '';
  @Input() titleTestId = '';
  @Output() back = new EventEmitter<void>();
}
